<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    // window.addEventListener("orientationchange", this.toOrientation);
  },
  methods: {
    // toOrientation() {
    //   this.$router.go(0);
    //   switch (screen.orientation.type) {
    //     //   横屏
    //     case "landscape-primary":
    //     // 横屏上下颠倒
    //     case "landscape-secondary":
    //       break;
    //     //   竖屏上下颠倒
    //     case "portrait-secondary":
    //     //   竖屏
    //     case "portrait-primary":
    //       break;
    //     default:
    //     //  结束
    //   }
    // }
  }
};
</script>

<style>
@import "../src/assets/style/allstyle";
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  background: #f0f1f6;
  min-height: 100vh;
}
/* @media screen and (orientation: portrait) {
  body {
    transform-origin: 0 0;
    transform: rotateZ(90deg) translateY(-100%);
  }
} */
</style>



// WEBPACK FOOTER //
// src/App.vue